import useTheme from "@mui/material/styles/useTheme";
import { observer } from "mobx-react-lite";
import React from "react";
import LockHorzRotationIcon from "../icon/toolbar/LockHorzRotationIcon";
import IconButton3D from "./IconButton3D";
import { useStore } from "csi/state/hooks";

const LockHorzRotation = observer(() => {
	const { palette } = useTheme();	
	const secondary = palette.NavListItemSelectedBG;
	const rootStore = useStore();
	const { threeDStore: { modelViewerStore } } = rootStore;
	const { toggleLockPolarRotation, lockPolarAngle } = modelViewerStore;
  
	return (
		<IconButton3D
			fontSize={26}  
			onClick = {toggleLockPolarRotation}
			res="3DViewRotate"
			sx={{
				backgroundColor : lockPolarAngle ? secondary : "transparent",
			}}            
		>
			<LockHorzRotationIcon
				selected={lockPolarAngle}
			/>
		</IconButton3D>
	);
});

export default LockHorzRotation;